module.exports = __webpack_public_path__ + "static/media/previewlifestyle4-small.45f8ae9c.jpg";